export default __webpack_public_path__ + "static/media/companies-iprop-up.2b9e8ab4.svg";